var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./HomeFiskultura.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2dd5b734!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./HomeFiskultura.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Home/HomeFiskultura.vue
// module id = 610
// module chunks = 0